module.exports = __webpack_public_path__ + "img/catching.b906cdfe.svg";